import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IDeleteUserConnectedDevicesParams {
  userId: string;
  deviceIds: string[];
}

export class DeleteUserConnectedDevicesRequest extends Request<IDeleteUserConnectedDevicesParams, IResult> {
  constructor(params: IDeleteUserConnectedDevicesParams) {
    super('deleteUserConnectedDevices', params);
  }
}
